<template>
    <div style="
    background: #fff;
">
        <div style="padding-top: 5px;">
            <DownloadHeader />
            <van-row style="margin-top: 60px; align-items: center;">
                <van-col span="6">
                    <div style=" display: flex; justify-content: center; align-items: center; padding: 15px 2px;">
                        <img style="height: 65px; width: 65px; object-fit: contain; border-radius: 15px; border: 0.5px solid #000;"
                            src="@/assets/download/head_icon.png" />
                    </div>
                </van-col>
                <van-col span="18" style="padding-left:5px ;">
                    <div style=" display: flex; justify-content: flex-start; align-items: center;color: #000;">
                        <div style="margin: 5px 0; margin: 5px 0px; font-size: 28px; font-weight: 500;">{{
                            $t('donwload.appName') }}</div>
                    </div>
                    <div style=" display: flex; justify-content: flex-start; align-items: center;">
                        <span style="color: #01875f;font-weight: 600; font-size: 16px; padding-bottom: 5px;">{{
                            $t('donwload.title') }}</span>
                    </div>
                    <div style=" display: flex; justify-content: flex-start; align-items: center;">
                        <span style="color: #5f6368;font-size: 13px;">{{ $t('donwload.subtitle') }}</span>
                    </div>
                </van-col>
            </van-row>
            <AppData />
            <van-row style="margin-top: 5px;">
                <van-col span="24">
                    <div
                        style=" display: flex; justify-content: center; align-items: center; padding: 15px 30px 15px 30px;">
                        <van-button class="dialog_button" @click="installApp"
                            style="border-radius: 10px; background-color: #01875f; height: 55px; padding: 10px; display: flex; flex-direction: column; align-items: center;">
                            <span
                                style="color: #ffe336; padding-bottom: 2px; align-items: center; display: flex; justify-content: center; font-size: 14px;">
                                <img style="height: 20px; width: 20px;" src="@/assets/download/flashThunder.svg" />
                                {{ $t('donwload.rapidDonwload') }}
                            </span>
                            <span style="color: #fff; font-size: 12px; margin-bottom: 3px;">
                                {{ $t('download.withinSec') }}
                            </span>
                        </van-button>
                    </div>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12">
                    <div
                        style=" display: flex; justify-content: center; align-items: center; padding: 15px 10px 15px 10px;">
                        <van-icon name="share" size="25" color="#01875f" />
                        <span style="color:#01875f; font-size: 15px; margin-left: 6px;">{{ $t('download.share')
                        }}</span>
                    </div>
                </van-col>
                <van-col span="12">
                    <div
                        style=" display: flex; justify-content: center; align-items: center; padding: 15px 10px 15px 10px;">
                        <van-icon name="bookmark" size="25" color="#01875f" />
                        <span style="color:#01875f; font-size: 15px; margin-left: 6px;">{{ $t('download.wishList')
                        }}</span>

                    </div>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="24">
                    <div
                        style="height: 200px; display: flex; justify-content: center; align-items: center; padding: 5px 18px 5px 18px;;">
                        <img style="height: 100%; width: 100%; object-fit: fill; border-radius: 10px"
                            src="@/assets/download/banner.jpg" />
                    </div>
                </van-col>
            </van-row>

            <div class="textContent" style="padding: 25px 18px 1px 18px;">
                <ArrowContent :heading="$t('download.aboutGame')" :content="$t('download.appDataContent')"
                    :htmlValue="true"></ArrowContent>
                <van-row style="margin-top: 0px;">
                    <van-col :span="24">
                        <p style="font-size: 15px;color: #000;">{{ $t('donwload.updatedOn')
                        }}</p>
                    </van-col>
                </van-row>
                <van-row style="margin-top: 3px;">
                    <van-col :span="24">
                        <p style="font-weight: 400; color: #5f6368; font-size: 13px;margin: 0px;">{{ updatedDate }}</p>
                    </van-col>
                </van-row>
            </div>
            <van-row style="margin-top: 3px; padding: 25px 0px 0px 18px; font-weight: 600; ">
                <van-col :span="8">
                    <van-tag class="tagList" :plain="true" round type="primary" color="#5f6368" size="large">{{
                        $t('download.casino') }}</van-tag>
                </van-col>
                <van-col :span="2"></van-col>
                <van-col :span="8">
                    <van-tag class="tagList" :plain="true" round type="primary" color="#5f6368" size="large">{{
                        $t('download.slotMach') }}</van-tag>

                </van-col>
            </van-row>
            <div class="textContent" style="padding: 30px 18px 1px 18px;">
                <ArrowContent style="height:40px;" :heading="$t('download.dataSecurity')"
                    :content="$t('download.appSecurity')">
                </ArrowContent>
                <div style="border: 1px solid #dadce0; border-radius: 10px;margin-top: 5px; padding-bottom: 10px;">
                    <SecurityList ref="securityListRef"></SecurityList>
                    <div style="margin:20px 0px 0px 30px;">
                        <span style=" color: #01875f; font-size: 14px;">{{ $t('lottery.moreDetails') }}</span>

                    </div>
                </div>
            </div>
            <div class="textContent" style="padding: 30px 18px 1px 18px;">
                <van-row style="align-items: center;">
                    <van-col span="16">
                        <div style=" display: flex; justify-content: flex-start; align-items: center; ">
                            <span style="font-size: 18px;font-weight: 600;color: #000;">{{
                                $t('donwload.ratingAndReview') }}</span>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div
                            style=" display: flex; justify-content: flex-end; align-items: center; padding-right: 5px;">
                            <van-icon name="arrow" size="15" color="#5f6368" />
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="16">
                        <div
                            style=" display: flex; justify-content: flex-start; align-items: center; padding-top: 7px; color: #5f6368; ">
                            <span style="font-size: 13px; font-weight: 400;  margin-right: 5px; ">{{
                                $t('donwload.vefied') }}</span>
                        </div>
                    </van-col>
                    <van-col :span="4">
                        <div
                            style=" display: flex; justify-content: flex-start; align-items: center; padding-top: 10px; color: #5f6368; ">
                            <van-icon name="info-o" size="14" color="#5f6368" />
                        </div>
                    </van-col>

                </van-row>
                <van-row style="margin-top: 3px; padding: 30px 0px 30px 0px; font-weight: 500; ">
                    <van-col :span="8">
                        <van-tag round :plain="true" class="tagList" :text="$t('download.telephone')" size="large"
                            borderColor="transparent" bgColor="#e6f3ef" color="#01875f" shape="circle">
                            <img src="@/assets/download/phone.png" alt="icon"
                                style="height: 16px; width: 16px; margin-right: 5px;" />
                            {{ $t('download.telephone') }}
                        </van-tag>

                    </van-col>
                    <van-col :span="2"></van-col>
                    <van-col :span="8">
                        <van-tag round :plain="true" class="tagList" size="large" borderColor="#dadce0" color="#5f6368"
                            shape="circle">
                            <img src="@/assets/download/tablet.png" alt="icon"
                                style="height: 16px; width: 16px; margin-right: 5px; filter: brightness(0.5);" />
                            {{ $t('download.tablet') }}
                        </van-tag>

                    </van-col>
                </van-row>

                <van-row>
                    <van-col span="10">
                        <div
                            style=" display: flex; justify-content: flex-start; flex-direction: column;margin-top: -20px;">
                            <span style="font-size: 50px;font-weight: 400;color: #202124;">4.9</span>
                            <div style=" display: flex; justify-content: flex-start; flex-direction: row; ">
                                <van-icon name="star" style="padding: 2px;" v-for="i in 5" :key="i" size="14"
                                    color="#01875f" />
                            </div>
                            <span style="font-size: 14px;font-weight: 400;color: #5f6368;margin-top: 3px;">{{
                                $t('download.reviewCount') }}</span>

                        </div>
                    </van-col>
                    <van-col :span="14">
                        <RateBar :rateNum="5" :percentage='92'></RateBar>
                        <RateBar :rateNum="4" :percentage='2'></RateBar>
                        <RateBar :rateNum="3" :percentage='1'></RateBar>
                        <RateBar :rateNum="2" :percentage='2'></RateBar>
                        <RateBar :rateNum="1" :percentage='2'></RateBar>

                    </van-col>

                </van-row>
                <div style="padding: 30px 0px 1px 0px;">
                    <UserComment :img="users[0].img" name="Lara Liras" :comment="$t('download.commentOne')"
                        :commentDate="$t('download.commentDateOne')" :redivCount="52"></UserComment>
                    <UserComment :img="users[1].img" name="Angelita Da Silva" :comment="$t('download.commentTwo')"
                        :commentDate="$t('download.commentDateTwo')" :redivCount="22"></UserComment>
                    <UserComment :img="users[2].img" name="Rubens Vieira dos Santos"
                        :comment="$t('download.commentThree')" :commentDate="$t('download.commentDateThree')"
                        :redivCount="20"></UserComment>
                </div>
                <div style="padding: 30px 0px 1px 0px;">
                    <span style="font-weight: 600;font-size: 14px; color: #01875f;padding-top: 10px;">{{
                        $t('download.seeAllReview') }}</span>

                </div>
                <div style="padding: 30px 0px 1px 0px;">
                    <span style="font-size: 20px;font-weight: 600;color: #000;">{{ $t('donwload.whatsNew') }}</span>
                    <div style="color: rgb(95, 99, 104);; font-size: 16px; font-weight: 100;">
                        <p style="margin: 15px 0 0 0;">{{ $t('download.helloFan') }}</p>
                        <p style="margin: 3px 0 0 0;">{{ $t('download.newUpdate') }}</p>
                        <p style="margin: 15px 0 0 0;">{{ $t('download.perFormUpdate') }}</p>
                        <p style="margin: 15px 0 0 0;">{{ $t('download.enjoy') }}</p>
                    </div>
                </div>
                <div style="padding: 15px 0px 0px 0px;">
                    <van-row>
                        <van-col span="16">
                            <div style=" display: flex; justify-content: flex-start; align-items: center; ">
                                <span style="font-size: 20px;font-weight: 600;color: #000;padding: 5px 0px;">{{
                                    $t('download.similarGame') }}</span>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div
                                style=" display: flex; justify-content: flex-end; align-items: center; padding-right: 5px;">
                                <van-icon style="padding: 10px 0px;" size="15" color="#5f6368" name="arrow"
                                    :bold=true></van-icon>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div style="padding: 30px 0px 1px 0px;">
                    <van-row>
                        <van-col :span="12">
                            <SimilarGame :img="games[0].img" gameName="Cash Craze:" subHeading="Casual Joy Ga"
                                :rate="4.5">
                            </SimilarGame>
                        </van-col>
                        <van-col :span="12">
                            <SimilarGame :img="games[1].img" gameName="Charge Buffa" subHeading="FUFAFA TECHN"
                                :rate="4.5">
                            </SimilarGame>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col :span="12">
                            <SimilarGame :img="games[2].img" gameName="Jackpot Mag" subHeading="Big Fish Game"
                                :rate="2.6"></SimilarGame>
                        </van-col>
                        <van-col :span="12">
                            <SimilarGame :img="games[3].img" gameName="Diamond Slot" subHeading="International G"
                                :rate="3.9"></SimilarGame>
                        </van-col>

                    </van-row>
                    <van-row>
                        <van-col :span="12">
                            <SimilarGame :img="games[4].img" gameName="Bônus Bingo" subHeading="FUFAFA TECHN"
                                :rate="4.4">
                            </SimilarGame>
                        </van-col>
                        <van-col :span="12">
                            <SimilarGame :img="games[5].img" gameName="Infinity Slots" subHeading="Murka Games"
                                :rate="4.5"></SimilarGame>
                        </van-col>

                    </van-row>
                </div>
                <div style="padding: 10px 0px 1px 0px;">
                    <van-row>
                        <van-col :span="2">
                            <img style="height: 20px; width: 20px; object-fit: cover;border-radius: 10px"
                                src="@/assets/download/flag.png" />
                        </van-col>
                        <van-col :span="20">
                            <span style="padding-left: 10px; display: flex; justify-content: flex-start;color: #000;">{{
                                $t('download.flagMsg') }}</span>
                        </van-col>
                    </van-row>
                </div>
                <div style="border: 1px solid #e8eaed; width: 100%; margin: 50px 0px;"></div>
                <div style="display: flex; flex-direction: column;line-height: 30px;color: #5f6368;">
                    <span style="font-size: 14px; font-weight: 600;">{{ $t('download.googlePlay') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.playPass') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.playPoint') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.gift') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.rescue') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.refund') }}</span>
                </div>
                <!-- <div style="padding-top: 30px; display: flex; flex-direction: column;line-height: 30px;color: #5f6368;">
                    <span style="font-size: 14px; font-weight: 600;">{{ $t('download.childFam') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.guide') }}</span>
                    <span style="font-size: 14px; font-weight: 400;">{{ $t('download.sharing') }}</span>
                </div> -->
                <div style="padding: 60px 0px 1px 0px;display: flex;justify-content: flex-start; color: #5f6368;">
                    <van-row style="width: 100%;">
                        <van-col :span="8" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.terms') }}</span>
                        </van-col>
                        <van-col :span="12" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.privacy') }}</span>
                        </van-col>
                        <van-col :span="8" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.about') }}</span>
                        </van-col>
                        <van-col :span="12" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.developer') }}</span>
                        </van-col>
                        <van-col :span="8" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.store') }}</span>
                        </van-col>
                        <van-col :span="16" style="width:100%; padding:10px 0;">
                            <span>{{ $t('download.allPrice') }}</span>
                        </van-col>
                    </van-row>
                </div>
                <div style="padding: 10px 0px 1px 0px;display: flex;justify-content: flex-start; color: #5f6368;">
                    <van-row style="width: 100%;">


                    </van-row>
                </div>
                <div style="padding: 20px 0px 60px 0px;display: flex;justify-content: flex-start; color: #5f6368;">
                    <van-row>
                        <van-col :span="6" style="padding: 5px;">
                            <img style="height: 18px; width: 24px; object-fit: cover;"
                                src="@/assets/download/flag.jpg" />
                        </van-col>
                        <van-col :span="18" style="padding: 5px;width: 200px;">
                            <span>{{ $t('download.bottomNotice') }}</span>
                        </van-col>
                    </van-row>
                </div>

            </div>

        </div>

        <DownloadFooter />

        <DownloadPlatformSelectionPopup
            ref="downloadPopup"
            @select="onPlatformSelect"
        />
    </div>
</template>

<script setup lang="ts">
import AppData from "./components/AppData.vue";
import ArrowContent from "./components/ArrowContent.vue";
import SecurityList from "./components/SecurityList.vue";
import RateBar from "./components/RateBar.vue";
import UserComment from "./components/UserComment.vue";
import SimilarGame from "./components/SimilarGame.vue";
import DownloadHeader from "./components/DownloadHeader.vue";
import DownloadFooter from "./components/DownloadFooter.vue";
import DownloadPlatformSelectionPopup from "./components/DownloadPlatformSelectionPopup.vue";
import { computed, onMounted, ref } from "vue";
import { getAndroidDownloadURL } from "@/api/common";


const updatedDate = ref('Feb 10,2025')

const users = ref([
    { img: require('@/assets/download/coment1.png') },
    { img: require('@/assets/download/coment2.png') },
    { img: require('@/assets/download/coment3.png') }
])

const games = ref([
    { img: require('@/assets/download/similarOne.png') },
    { img: require('@/assets/download/similarTwo.png') },
    { img: require('@/assets/download/similarThree.png') },
    { img: require('@/assets/download/similarFour.png') },
    { img: require('@/assets/download/similarFive.png') },
    { img: require('@/assets/download/similarSix.png') }
])
const deferredPrompt = ref<Event | null>(null);
const canInstall = ref(false);
const downloadPopup = ref<InstanceType<typeof DownloadPlatformSelectionPopup> | null>(null);

const isSupported = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes("chrome") || ua.includes("chromium") || ua.includes("edge");
};

const pwaSupported = computed(() => {
    return canInstall.value
        && isSupported()
        && !!deferredPrompt.value
        && 'prompt' in deferredPrompt.value;
});

const installApp = () => {
    downloadPopup.value?.open(pwaSupported.value);
};

const installPWA = () => {
    if (deferredPrompt.value && 'prompt' in deferredPrompt.value) {
        const promptEvent = deferredPrompt.value as any;
        promptEvent.prompt();
        deferredPrompt.value = null;
    }
};

const onPlatformSelect = (type: 'pwa' | 'apk') => {
    if (type === 'pwa') {
        installPWA();
    } else {
        apkBundleDownload();
    }
};

// PWA install prompt
window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault();
    deferredPrompt.value = e;
    canInstall.value = true;
});

const saveTokenFromQuery = () => {
    let params: URLSearchParams;

    if (window.location.search) {
        params = new URLSearchParams(window.location.search);
    } else if (window.location.hash.includes("?")) {
        const hashQuery = window.location.hash.split("?")[1];
        params = new URLSearchParams(hashQuery);
    } else {
        return;
    }

    const token = params.get("token");
    const clientId = params.get("clientId");
    const tenantId = params.get("tenantId");

    if (token) localStorage.setItem("token", token);
    if (clientId) localStorage.setItem("clientId", clientId);
    if (tenantId) localStorage.setItem("tenantId", tenantId);

    //Clean the URL right after saving (so it won’t restore again)
    // cleanURL();
};

const cleanURL = () => {
    const baseUrl = window.location.origin + window.location.pathname;

    // Keep only the hash route, strip query params after '?'
    const cleanHash = window.location.hash.split("?")[0] || "";

    // Replace URL without reloading
    window.history.replaceState({}, document.title, baseUrl + cleanHash);
};
const apkBundleDownload = () => {
    const data = {
        paramString: "android_download_url",
    }
    getAndroidDownloadURL(data).then(res => {
        const downloadUrl = res.data?.android_download_url || ''
        window.open(downloadUrl);
    }).catch(err => {
        console.log("claim err: ", err);
    })
}
onMounted(() => {

    saveTokenFromQuery()
})
</script>


<style scoped>
.tagList {
    padding: 10px 0px;
    justify-content: center;
    width: 100%;
}

.textContent {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 100;
    font-size: 14px;
}

.dialog_button {
    width: 100%;
}

.dialog_button {
    position: relative;
    overflow: hidden;
}

.dialog_button::before {
    content: "";
    position: absolute;
    top: 0;
    left: -75%;
    width: 50%;
    height: 100%;
    background: linear-gradient(120deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.6) 50%,
            rgba(255, 255, 255, 0.2) 100%);
    transform: skewX(-25deg);
    animation: shine 2s infinite;
}

@keyframes shine {
    0% {
        left: -75%;
    }

    100% {
        left: 125%;
        /* move to right outside */
    }
}


.navLeft {
    display: inline-flex;
    margin-top: 6px;
}

.navImages {
    width: 30px;
    height: 30px;
}

.navHeading {
    font-size: 18px;
    color: rgb(255, 255, 255);
    padding-left: 8px;
    line-height: 30px;
}

.imageContainer {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 120px;
}

.scrollFinish {
    text-align: center;
    color: #969799;
    font-size: 13px;
    line-height: 40px;
    margin-top: -50px;
}

.topContainer {
    margin: 15px;
    background: url("@/assets/download/transfer.png");
    background-size: 100% 100%;
}

.emptyImg {
    text-align: center;
    padding: 30px;
}

#customerIconStyles {
    position: fixed !important;
    right: 0 !important;
    bottom: 77px !important;
}
</style>
